import { VehicleIdTypeOptions } from 'even-ts-static'
import { Fields } from 'embed/constants/fields'
import { Field, FieldDataValue } from 'embed/constants'

type VehicleIdTypeChangeHandler = (fields: Field[], value: VehicleIdTypeOptions) => void

export const handleVehicleIdTypeChange: (
  changeHandler: VehicleIdTypeChangeHandler,
) => (value: FieldDataValue) => void = (changeHandler) => (value: VehicleIdTypeOptions) => {
  const fieldsToUnregister = {
    [VehicleIdTypeOptions.VEHICLE_IDENTIFICATION_NUMBER]: [Fields.LicensePlateNumber, Fields.LicensePlateState],
    [VehicleIdTypeOptions.LICENSE_PLATE]: [Fields.VehicleIdentificationNumber],
  }

  changeHandler(fieldsToUnregister[value], value)
}
